import React from 'react';
import PropTypes from 'prop-types';
import Lightbox from 'react-images';
import moment from 'moment-timezone';

const defaultState = { lightboxIsOpen: false, currentImage: 0 };

export default class AccountPlayerUploads extends React.Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = defaultState;
  }

  openLightbox = e => {
    e.preventDefault();
    this.setState({ currentImage: parseInt(e.target.dataset.index, 10), lightboxIsOpen: true });
  }

  closeLightbox = () => {
    this.setState(defaultState);
  }

  gotoPrevious = () => {
    this.setState({ currentImage: this.state.currentImage - 1 });
  }

  gotoNext = () => {
    this.setState({ currentImage: this.state.currentImage + 1 });
  }

  gotoImage = (index) => {
    this.setState({ currentImage: index });
  }

  handleClickImage() {
    if (this.state.currentImage === this.props.data.chart.length - 1) return;
    this.gotoNext();
  }

  render() {
    const { data, title } = this.props;
    const images = data.chart.map(img => { return { src: img.mediaUrl, caption: `Card: ${img.cardTitle}` } });
    const gallery = data.chart.map((img, i) => (
      <div key={`thumb-${img.id}`} className='o-gallery__item'>
        <a href={img.mediaUrl} data-index={i} onClick={this.openLightbox}>
          <div data-index={i} className='o-gallery__thumbnail' style={{ backgroundImage: `url("${img.mediaUrl}")` }} title={`Card: ${img.cardTitle}`} />
        </a>
        <div className='o-gallery__date'>{moment(img.updatedAt).format('L')}</div>
      </div>
    ));
    return (
      <div className='o-dashboard-card__wrap u-margin-bottom--large'>
        <strong>{title}</strong>
        <div className='o-gallery-card'>
          <div className='o-gallery-card__stats u-flex cs-bg--light'>
            <div className='column shrink'>
              <span className='u-txt--stat-value'>{data.total.value}</span><br />
              <span className='u-txt--stat-label'>{data.total.label}</span>
            </div>
          </div>
          <div className='u-flex'>
            <div className='o-gallery__wrap cs-bg--light u-padding-bottom--gutter u-margin-bottom--large'>
              <div className='o-gallery u-margin-top--base'>
                {gallery}
              </div>
            </div>
          </div>
          <Lightbox
            currentImage={this.state.currentImage}
            images={images}
            isOpen={this.state.lightboxIsOpen}
            onClickImage={this.handleClickImage}
            onClickPrev={this.gotoPrevious}
            onClickNext={this.gotoNext}
            onClose={this.closeLightbox}
          />
        </div>
      </div>
    );
  }
}
